<template>
	<modal-item-comp v-for="(modal, index) in modals" :key="modal.uuid" :modal="modal" :index="baseZIndex + index"></modal-item-comp>
</template>

<script lang="ts">
import { ModalItem } from '@/models/AppConfig'
import { STATE_MODULES } from '@/store/state-modules';
import { ConfigGetters } from '@/store/modules/config/getters'
import { defineComponent } from 'vue'
import ModalItemComp from './ModalItem.vue'

export default defineComponent({
	setup () {
		return {}
	},
	computed: {
		modals (): ModalItem[] {
			return this.$store.getters[`${STATE_MODULES.CONFIG}/${ConfigGetters.MODALS_LIST}`]
		},
		hasModal (): boolean {
			return !!this.modals.length;
		}
	},
	components: {
		ModalItemComp
	},
	data () {
		return {
			baseZIndex: 2000
		}
	},
	watch: {
		hasModal (val) {
			if (val) {
				document.body.style.overflow = 'hidden';
			} else {
				document.body.style.overflow = '';
			}
		}
	}
})
</script>

<style scoped>
</style>
